const REDUX_API_STATUS = {
  // Used by auth only: the app has not yet determined whether a session
  // exists, so the router must show the loading screen — never Login.
  INITIALIZING: "INITIALIZING",
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

export { REDUX_API_STATUS };
